import { styled } from '@mui/material/styles';

export const StyledDetailSectionContainer = styled('div')`
  ${({ theme }) => theme.breakpoints.down(760)} {
    & > div[data-test='deal-details'] > .MuiGrid-container {
      padding: ${({ theme }) => theme.spacing(4, 1)};
    }
  }
`;
